import { Button } from "@/components/ui/button";
import { PAGE_SIZE } from "@/lib/constants";

interface LoadMoreButtonProps {
  hasMore: boolean;
  loading: boolean;
  loadedCount: number;
  totalCount?: number;
  pageSize?: number;
  onClick: () => void;
}

export function LoadMoreButton({
  hasMore,
  loading,
  loadedCount,
  totalCount,
  pageSize = PAGE_SIZE,
  onClick,
}: LoadMoreButtonProps) {
  if (!hasMore) return null;

  return (
    <div className="flex justify-center py-4">
      <Button variant="outline" onClick={onClick} disabled={loading}>
        {loading
          ? "Loading..."
          : `Load ${pageSize} more${
              totalCount != null
                ? ` (showing ${loadedCount} of ${totalCount})`
                : ` (${loadedCount} loaded)`
            }`}
      </Button>
    </div>
  );
}
